/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Checkbox, NumberInput, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { FaBackward } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { addOrder } from "../../../redux/actions/frontendActions/OrderActions";
import { getPriceDetails } from "../../../redux/actions/frontendActions/pricingAction";
import OnlyFooter from "../../common_components/OnlyFooter";
import Navbar from "../../layout_components/Navbar";


function PricingDetails() {
  const { OrderErrorMessage ,  OrderSuccessMessage , loader}=useSelector(state =>state.Order)
  const { pricingSuccessMessage } = useSelector((state) => state.Pricing);
  const { myInfo } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const { id } = useParams();
  useEffect(() => {
    dispatch(getPriceDetails(id));
  }, [id]);

  const [state, setState] = useState({
    productId: pricingSuccessMessage._id,
    productPrice: pricingSuccessMessage.price,
    productTitle: pricingSuccessMessage.title,
    productCategory: pricingSuccessMessage.categories,
  });

  // handle input
  const handleInput = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const form = useForm({
    initialValues: {
      firstName: myInfo.firstName,
      lastName: myInfo.lastName,
      phone: myInfo.phone,
      email: myInfo.email,
      status: myInfo.status,
      image: myInfo.image,
      address: "",
    },

    validate: {
      firstName: (value) =>
        value.length < 2 ? "First Name rquired  with 2 caracter " : null,
      lastName: (value) =>
        value.length < 2 ? "Last Name required with 2 caracter" : null,
      phone: (value) =>
        value.length < 11 ? "Phone number would be 11 digits" : null,

      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      address: (value) => (value.length === 0 ? "Add Address.." : null),
    },
  });

  const handleOrderSubmit = () => {

    const { firstName, lastName, email, phone, address ,image } = form.values;



    const formData = new FormData();
    formData.append("pName", state.productTitle);
    formData.append("pPrice", state.productPrice);
    formData.append("pCategories", state.productCategory);
    formData.append("pId", state.productId);

    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("address", address);
    formData.append("image",image );

    dispatch(addOrder(formData))
  };


useEffect(() =>{
if( OrderSuccessMessage){
  toast.success( OrderSuccessMessage);
 window.location="/pricing"
}
if(OrderErrorMessage){
  toast.error(OrderErrorMessage)
}
}, [OrderErrorMessage ,  OrderSuccessMessage]);














  return (
    <>
      <Navbar />
      <Toaster position={'bottom-center'}
                reverseOrder={false}
                toastOptions={
                    {
                        style: {
                            fontSize: '15px'
                        }
                    }
                }
            />

      <div className="check_out">
        <div className="check-bg">
          <h1>Check out /</h1>
          <Link to="/pricing">
            <FaBackward /> Back to page
          </Link>
        </div>
      </div>

      <div className="margin_container">
        <div className="chcek_grid">
          <div className="pricng_details_card">
            <div
              className={
                pricingSuccessMessage.color === "white"
                  ? "card"
                  : "card  purple"
              }
              key={pricingSuccessMessage._id}
            >
              <div className="grade">{pricingSuccessMessage.grade}</div>
              <div className="top_area">
                <h4 className="title">{pricingSuccessMessage.title}</h4>
                <div className="price_in_doller">
                  <div className="icon">$</div>
                  <div className="price">{pricingSuccessMessage.price}</div>
                </div>
                <p className="category">
                  Category: {pricingSuccessMessage.categories}
                </p>
                <p className="description">
                  {pricingSuccessMessage.description}
                </p>
              </div>
              <div className="features">
                <ul>
                  {pricingSuccessMessage?.features &&
                    pricingSuccessMessage?.features.map((f, i) => (
                      <li key={i}>
                        <TiTick /> <span>{f}</span>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="chcekout_user_info_card">
            <h3>Order Information</h3>
            <div className="form-area-wrapper">
              <form onSubmit={form.onSubmit(handleOrderSubmit)}>
                <h4>Product info.</h4>
                <div className="price_input-area">
                  <h6>$</h6>
                  <input
                  readOnly
                    onChange={handleInput}
                    name="productPrice"
                    type="text"
                    className="input-border-hide price-input"
                    value={pricingSuccessMessage.price}
                  />
                </div>
                <div className="price_name_input">
                  <input
                  readOnly
                    onChange={handleInput}
                    name="productTitle"
                    type="text"
                    className="input-border-hide price-input"
                    value={pricingSuccessMessage.title}
                  />
                </div>
                <div className="price_category_input">
                  <h6>Category</h6>{" "}
                  <input
                  readOnly
                    onChange={handleInput}
                    name="productCategory"
                    type="text"
                    className="input-border-hide price-input"
                    value={pricingSuccessMessage.categories}
                  />
                </div>

                <br />
                <h4>Account info.</h4>
                <div className="user-info-from-price-area">
                  <div className="form_item form_flex">
                    <div className="form_flex_item">
                      <TextInput
                      required
                        withAsterisk
                        label="First Name"
                        placeholder="Jhon"
                        {...form.getInputProps("firstName")}
                      />
                    </div>
                    <div className="form_flex_item">
                      <TextInput
                      required
                        withAsterisk
                        label="Last Name"
                        placeholder="Doe"
                        {...form.getInputProps("lastName")}
                      />
                    </div>
                  </div>
                  <div className="form_item">
                    <NumberInput
                    required
                      withAsterisk
                      label="Phone"
                      placeholder="Phone"
                      {...form.getInputProps("phone")}
                    />
                  </div>
                  <div className="form_item">
                    <TextInput
                    required
                      withAsterisk
                      label="Email Address"
                      placeholder="your@email.com"
                      {...form.getInputProps("email")}
                    />
                  </div>
                  <div className="form_item">
                    <TextInput
                    required
                      withAsterisk
                      label="Your Address"
                      placeholder="Dhaka , Bangladesh"
                      {...form.getInputProps("address")}
                    />
                  </div>
                  <div className="form_item" style={{ margin: "10px 0" }}>
                    <Checkbox label="No direct payment method is used for the convenience of users so that they can directly communicate the work." />
                  </div>

                  <div className="form_item">
                    <div className="submit_button">
                      <Button type="submit" variant="filled">
                        {
                          loader ? "Making Order": "Submit Order"
                        }
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <OnlyFooter />
    </>
  );
}

export default PricingDetails;
